// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3NK9h","label":"Labeled_label__RDrx6","divider":"Labeled_divider__1KHI1"};